var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"pa-3",attrs:{"flat":"","dark":_vm.contrastMode}},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.$t("FOOTER.TEXT"))+" © "+_vm._s(new Date().getFullYear()))])])}
var staticRenderFns = []

export { render, staticRenderFns }